import CryptoJS from "crypto-js";
//此处的密钥随机生成，可自行修改
// const key = CryptoJS.enc.Utf8.parse('9627F8751BAC3190'); //十六位十六进制数作为密钥
// const iv = CryptoJS.enc.Utf8.parse('AE14D873A093C352'); //十六位十六进制数作为密钥偏移量

 // 加密
 function aes_ecb_encrypt(word, keyStr) {
    let key = CryptoJS.enc.Utf8.parse(keyStr);
    let srcs = CryptoJS.enc.Utf8.parse(word);
    let encrypted = CryptoJS.AES.encrypt(srcs, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
}
// 解密
function aes_ecb_decrypt(word, keyStr) {
    var key = CryptoJS.enc.Utf8.parse(keyStr);
    var decrypt = CryptoJS.AES.decrypt(word, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
}

function get_aes_uuid() {
    return 'xxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
        return v.toString(16);
    });
}



export {aes_ecb_encrypt,aes_ecb_decrypt,get_aes_uuid
   
}